import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportChecklistUnits,
} from '../../../shared/fi-checklist2-report';
import { ChecklistProgressType } from '../../../enums/fi-checklist2-report-type';
import { FiChecklist2ReportFilterService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-filter.service';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';

@Component({
    selector: 'fi-open-checklists-chart',
    templateUrl: './open-checklists-chart.component.html',
    styleUrls: ['./open-checklists-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-open-checklists-chart' },
    standalone: false,
})
export class FiOpenChecklistsChartComponent {
    // we should be able to build chart data by any of arrays below, todo?
    @Input() filteredChecklistUnits: IChecklist2ReportChecklistUnits[];
    @Input() filteredOpenChecklistDetails: IChecklist2ReportChecklistSummary[];

    @Input() isChartInteractive: boolean;
    @Input() isChartSegmentsInteractive: boolean;
    @Output() onChartSegmentClick = new EventEmitter<ChecklistProgressType>();
    @Output() onChartClick = new EventEmitter<void>();

    constructor(private fiChecklist2ReportFilterService: FiChecklist2ReportFilterService) {}

    getChartData(): IReportChartData[] {
        const checklistReportChartData: IReportChartData[] = [];
        checklistReportChartData[ChecklistProgressType.InProgress] = {
            gradientColorLight: '#FFBE92',
            gradientColorBright: '#FF8E1C',
            value: this.getInProgressCount(),
        };
        checklistReportChartData[ChecklistProgressType.NotStarted] = {
            gradientColorLight: '#E5EFF5',
            gradientColorBright: '#C7C8C9',
            value: this.getNotStartedCount(),
        };
        checklistReportChartData[ChecklistProgressType.Completed] = {
            gradientColorLight: '#62FF72',
            gradientColorBright: '#13CA25',
            value: this.getCompletedCount(),
        };
        return checklistReportChartData;
    }

    chartClick() {
        this.onChartClick.emit();
    }

    chartSegmentClick($event: ChecklistProgressType) {
        this.onChartSegmentClick.emit($event);
    }

    getCompletedCount(): number {
        if (this.filteredChecklistUnits) {
            return this.fiChecklist2ReportFilterService.filterChecklistDataByProgressType(
                this.filteredChecklistUnits,
                ChecklistProgressType.Completed,
            ).length;
        }

        if (this.filteredOpenChecklistDetails) {
            return this.filteredOpenChecklistDetails.reduce(
                (partialSum, item) => partialSum + item.CompletedIterationsCount,
                0,
            );
        }
    }

    getInProgressCount(): number {
        if (this.filteredChecklistUnits) {
            return this.fiChecklist2ReportFilterService.filterChecklistDataByProgressType(
                this.filteredChecklistUnits,
                ChecklistProgressType.InProgress,
            ).length;
        }

        if (this.filteredOpenChecklistDetails) {
            return this.filteredOpenChecklistDetails.reduce(
                (partialSum, item) => partialSum + item.InProgressIterationsCount,
                0,
            );
        }
    }

    getNotStartedCount(): number {
        if (this.filteredChecklistUnits) {
            return this.fiChecklist2ReportFilterService.filterChecklistDataByProgressType(
                this.filteredChecklistUnits,
                ChecklistProgressType.NotStarted,
            ).length;
        }

        if (this.filteredOpenChecklistDetails) {
            return this.filteredOpenChecklistDetails.reduce(
                (partialSum, item) => partialSum + item.NotStartedIterationsCount,
                0,
            );
        }
    }
}
